module.exports = __webpack_public_path__ + "static/about_card-cb2416e79cf63cddf12147293af7c09a.jpg";